/**
 * all states from store
 */
export default {
  user: {},
  genders: null,
  token: "",
  sign_up_skeleton: null,
  partner_type_flip_signup: "pf",
  partner_terms: null,
};
